export function operationDeleteError(error, subject) {
  const status = error?.response?.status;
  if (!status) return `No se pudo confirmar la eliminación de ${subject}. No hubo respuesta del servidor; revisá la conexión y actualizá el tablero antes de volver a intentarlo.`;
  const data = error.response.data;
  const detail = typeof data === "object" && data
    ? [data.error, data.mensaje, data.msg].find((value) => typeof value === "string" && value.trim())
    : "";
  const hints = {
    401: "La sesión venció. Volvé a iniciar sesión.",
    403: "El servidor rechazó la eliminación. Revisá los permisos de tu usuario.",
    404: "El servidor no encontró el registro o la ruta de eliminación. Actualizá el tablero y volvé a intentarlo.",
    405: "El servidor no admite esta solicitud de eliminación. Contactá al administrador.",
    409: "El registro fue modificado por otra persona. Actualizá el tablero y volvé a intentarlo.",
    429: "Hay demasiadas solicitudes. Esperá un momento y volvé a intentarlo.",
  };
  return `${detail ? detail.slice(0, 500) : hints[status] || `No se pudo eliminar ${subject} en el servidor.`} (HTTP ${status})`;
}
